import { render, staticRenderFns } from "./DiagnoseDetail.vue?vue&type=template&id=46adc574&scoped=true"
import script from "./DiagnoseDetail.vue?vue&type=script&lang=js"
export * from "./DiagnoseDetail.vue?vue&type=script&lang=js"
import style0 from "./DiagnoseDetail.vue?vue&type=style&index=0&id=46adc574&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46adc574",
  null
  
)

export default component.exports